import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <img 
                src="/images/duru-logo.png" 
                alt="Duru Halı Yıkama Logo" 
                className="h-16 w-auto object-contain"
              />
            </Link>
            <p className="text-sm text-gray-400 mb-4">
              {companyInfo.tagline} - Halı, koltuk ve ev tekstili yıkama hizmetlerinde 
              güvenilir adresiniz.
            </p>
            <div className="flex space-x-3">
              <a href="#" className="w-8 h-8 bg-gray-800 hover:bg-teal-600 rounded-full flex items-center justify-center transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="https://www.instagram.com/bahcesehir_duru_hal_ykama" target="_blank" rel="noopener noreferrer" className="w-8 h-8 bg-gray-800 hover:bg-teal-600 rounded-full flex items-center justify-center transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" className="w-8 h-8 bg-gray-800 hover:bg-teal-600 rounded-full flex items-center justify-center transition-colors">
                <Twitter className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Hızlı Linkler</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" onClick={() => window.scrollTo(0, 0)} className="text-sm hover:text-teal-400 transition-colors">Ana Sayfa</Link>
              </li>
              <li>
                <Link to="/hizmetler" onClick={() => window.scrollTo(0, 0)} className="text-sm hover:text-teal-400 transition-colors">Hizmetlerimiz</Link>
              </li>
              <li>
                <Link to="/hali-turleri" onClick={() => window.scrollTo(0, 0)} className="text-sm hover:text-teal-400 transition-colors">Halı Türleri</Link>
              </li>
              <li>
                <Link to="/blog" onClick={() => window.scrollTo(0, 0)} className="text-sm hover:text-teal-400 transition-colors">Blog</Link>
              </li>
              <li>
                <Link to="/hakkimizda" onClick={() => window.scrollTo(0, 0)} className="text-sm hover:text-teal-400 transition-colors">Hakkımızda</Link>
              </li>
              <li>
                <Link to="/iletisim" onClick={() => window.scrollTo(0, 0)} className="text-sm hover:text-teal-400 transition-colors">İletişim</Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Hizmetlerimiz</h3>
            <ul className="space-y-2">
              <li className="text-sm">Halı Yıkama</li>
              <li className="text-sm">Koltuk Yıkama</li>
              <li className="text-sm">Stor Perde</li>
              <li className="text-sm">Yorgan Yıkama</li>
              <li className="text-sm">Battaniye Yıkama</li>
              <li className="text-sm">Ücretsiz Servis</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">İletişim</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-teal-500 mt-0.5 flex-shrink-0" />
                <div className="text-sm">
                  <a href={`tel:${companyInfo.phones[0]}`} className="hover:text-teal-400 transition-colors block">
                    {companyInfo.phones[0]}
                  </a>
                  <a href={`tel:${companyInfo.phones[1]}`} className="hover:text-teal-400 transition-colors block">
                    {companyInfo.phones[1]}
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-teal-500 mt-0.5 flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="text-sm hover:text-teal-400 transition-colors">
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-teal-500 mt-0.5 flex-shrink-0" />
                <span className="text-sm">{companyInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-400">
            © {currentYear} {companyInfo.fullName}. Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
